//#region Imports

//#region Bootstrap

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Pagination from "react-bootstrap/Pagination";
import Placeholder from "react-bootstrap/Placeholder";
import Container from "react-bootstrap/Container";
import Stack from "react-bootstrap/Stack";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Card from "react-bootstrap/Card";

import Tooltip from "react-bootstrap/Tooltip";
// import CloseButton from "react-bootstrap/CloseButton";
//#endregion

//#region fontAwsome
import {
  faArrowDown,
  faClose,
  faDownload,
  faEye,
  faFile,
  faSearch,
  faTasks,
  faXmark
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//#endregion

//#region Composants
import {
  FiltrerParCollones,
  FiltrerParSearch,
  FiltrerParSeuil,
  FiltrerParSeuilDate,
  GenerateUid,
  RegexTestAndReturnMatch,
  base64toBlob,
  getMimeTypeFromExtension,
  groupBy,
} from "../../functions";
import RowDocument from "./RowDocument";
import { ReactComponent as Filter } from "../../image/filtre.svg";
import { ReactComponent as TooltipSvg } from "../../image/tooltip.svg";
import { ReactComponent as FilterReset } from "../../image/filtre-effacer.svg";

import { VoirFactureDocument } from "../../axios/WS_Factures";
import {
  GetPrestationReleveTache, GetDocumentPrestation, GetDocumentPrestationCERFA, GetDocumentPrestationExtranet, GetDocumentPrestationRapport, GetDocumentPrestationTicket,
} from "../../axios/WS_Contrat";
import { GetListeFIIntervention, GetListeFactureIntervention, GetDocumentFISAV } from "../../axios/WS_Intervention";


//#region Contexts
import {
  ClientSiteContratContext, TokenContext,
  //  ViewerContext
} from "../../App";
import { PrestaContext } from "../../Views/Maintenance/Contrat/Components/ContratPrestations";

//#endregion

//#endregion

import { useContext, useEffect, useRef, useState } from "react";

import { Breakpoint, BreakpointProvider } from "react-socks";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { GetClientSiteBySearch } from "../../axios/WS_User";
import { useNavigate } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { error } from "jquery";

const TAGSELECTION = "_xSelection";
//#endregion

/**
 * @param {*} {Data : [], Headers: [], Cells: [], CardModel:{},  IsLoaded: bool,  Pagination: bool, ?ButtonFilters: [], ?FilterDefaultValue: {}, ?TopPannelRightToSearch: <></>, ?TopPannelLeftToSearch: <></>  ,?placeholdeNbLine; int,   }
 * @returns Une table
 */
const TableData = ({ ...props }) => {
  const tokenCt = useContext(TokenContext);

  // const viewerCt = useContext(ViewerContext);

  const ClientSiteCt = useContext(ClientSiteContratContext);

  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const [variantToast, setVariantToast] = useState("info");
  const [messageToast, setMessageToast] = useState("Téléchargement en cours");
  const [titleToast, setTitleToast] = useState("Téléchargement")


  const Data = () => {
    let _lData = [];
    if (props.Data === "500") {
      _lData = [];
    } else {
      _lData = JSON.parse(JSON.stringify(props.Data));
    }

    //Récursion pour colonne unbound et _xSelection
    for (let index = 0; index < _lData.length; index++) {
      const element = _lData[index];
      let _unboundColonne = JSON.parse(JSON.stringify(element));
      element.unboundColonne = _unboundColonne;
      element[TAGSELECTION] = arraySelector.includes(index);
    }

    //filtre par la barre de recherche
    if (String(search).length > 0  && _lData.length > 0) {
      _lData = _lData.filter((item) => FiltrerParSearchGlobal(item));
    }

    //Filtre par les boutons
    if (props.ButtonFilters && btFilterActif && _lData.length > 0) {
      let _filteractif = JSON.parse(JSON.stringify(btFilterActif));

      _lData = _lData.filter((data) => {
        if (Array.isArray(_filteractif.value)) {
          let _value = false;

          for (let index = 0; index < _filteractif.value.length; index++) {
            const element = _filteractif.value[index];
            _value = data[_filteractif.fieldname] === element ? true : _value;
          }

          return _value;
        } else {
          return data[_filteractif.fieldname] === _filteractif.value;
        }
      });
    }




    //Filtres par la recherche par colonne
    if (arraySearch.length > 0) {
      _lData = FiltrerParSearch(_lData, arraySearch);
    }


    //Filtres par valeur min & max
    if (arrayFilterSeuis.length > 0) {
      _lData = FiltrerParSeuil(_lData, arrayFilterSeuis);
    }
    //Filtres par valeur date du & au
    if (arrayFilterRangeDate.length > 0) {
      _lData = FiltrerParSeuilDate(_lData, arrayFilterRangeDate);
    }

    //Filtres par check
    _lData = FiltrerParCollones(_lData, arrayFilter);

    return _lData;
  };

  //#region States
  const [search, setSearch] = useState("");
  const [arrayFilter, setArrayFilter] = useState([]);
  const getArrayFilterStart = () => {
    let _array = [];
    const querryParameters = new URLSearchParams(window.location.search);
    const _filterSeuil = querryParameters.get("seuil");

    if (_filterSeuil) {
      let _newFilterAuto = { fieldname: _filterSeuil, max: Number.MAX_VALUE, min: querryParameters.get("value") }
      _array.push(_newFilterAuto);
    }

    return _array
  }
  const [arrayFilterSeuis, setArrayFilterSeuils] = useState(getArrayFilterStart);
  const [arrayFilterRangeDate, setArrayFilterRangeDate] = useState([]);



  const [arraySearch, setArraySearch] = useState([]);

  const getButtonFilterActif = () => {
    const querryParameters = new URLSearchParams(window.location.search);
    const _filterOncol = querryParameters.get("filtre")

    //Si il y a des filtres
    if (props.ButtonFilters && _filterOncol) {
      const _buttonFilterFind = props.ButtonFilters.find((bf) => bf.value.toString() === _filterOncol);
      if (_buttonFilterFind) {
        return _buttonFilterFind;
      }
    }

    return props.FilterDefaultValue ? props.FilterDefaultValue : null
  }

  const [btFilterActif, setBtFilterActif] = useState(
    getButtonFilterActif()
  );

  const [nbParPages, setNbParPages] = useState(10);
  const [pageActuelle, setPageActuelle] = useState(1);

  const [rowIndexSelected, setRowIndexSelected] = useState(null);

  const [arraySelector, setArraySelector] = useState([]);

  //#endregion

  //#region Fonctions

  const reactStringReplace = require("react-string-replace");
  function HighlightTextIfSearch(text) {
    if (
      String(search).length > 0 &&
      String(text).toUpperCase().includes(String(search).toUpperCase())
    ) {
      return (
        <span>
          {reactStringReplace(String(text), String(search), (match, i) => (
            <mark key={i}>{match}</mark>
          ))}
        </span>
      );
    } else {
      return text;
    }
  }

  function FiltrerParSearchGlobal(_litem) {
    // eslint-disable-next-line
    let _arrIs = Object.keys(_litem).map((key) => {
      let _cellToApply = props.Cells.find((c) => c.fieldname === key);

      if (_cellToApply && _cellToApply.isSearchable) {
        return String(_litem[key])
          .toString()
          .toLocaleUpperCase()
          .includes(String(search).toLocaleUpperCase());
      }
    });

    for (let index = 0; index < _arrIs.length; index++) {
      const element = _arrIs[index];
      if (element && element === true) return true;
    }
    return false;
  }

  // function IsFiltercheckboxShouldBeCheck(fieldname, item) {
  //   if (
  //     arrayFilter.findIndex(
  //       (filter) => filter.fieldname === fieldname && filter.item === item
  //     ) > -1
  //   )
  //     return true;
  //   return false;
  // }

  function IsButtonShouldBeCheck(fieldname) {
    if (
      arrayFilter.findIndex((filter) => filter.fieldname === fieldname) > -1
    ) {
      return true;
    }

    if (
      arrayFilterSeuis.findIndex((filter) => filter.fieldname === fieldname) >
      -1
    ) {
      return true;
    }

    if (
      arraySearch.findIndex((filter) => filter.fieldname === fieldname) > -1
    ) {
      return true;
    }

    if (
      arrayFilterRangeDate.findIndex(
        (filter) => filter.fieldname === fieldname
      ) > -1
    ) {
      return true;
    }

    return false;
  }

  const isFilterActive = (filter) => {
    if (!btFilterActif) return false;
    return (
      btFilterActif.fieldname === filter.fieldname &&
      btFilterActif.value === filter.value
    );
  };

  function ResetAffichage(pageActuelle) {
    // setGridColMDValue(12);
    setDocuments([]);
    setPageActuelle(pageActuelle);
  }

  //#endregion

  //#region LARGE

  //#region Events

  const _interval3seconde = (value) => {
    var _myInterval = setInterval(function () {
      var _search = document.getElementById("search-bar-table-data").value;
      if (value === _search) {
        clearInterval(_myInterval);
        GetClientSiteBySearch(tokenCt, _search, props.UserClientSite);
      } else {
        clearInterval(_myInterval);
      }
    }, 3000)
  }

  const handleSearch = (e) => {
    setSearch(e.target.value);

    if (props.IsUser) {
      _interval3seconde(e.target.value);
    } else {
      e.preventDefault();
      ResetAffichage(1);
    }
  };


  const handleTousFilter = () => {
    setBtFilterActif(null);
    ResetAffichage(1);
  };

  const handleFilterClick = (filter) => {
    setBtFilterActif(filter);
    ResetAffichage(1);
  };

  //#region Pagination
  const handlePagePrev = () => {
    if (pageActuelle > 1) {
      ResetAffichage(pageActuelle - 1);
      props.methodPagination && props.methodPagination();
    }
  };

  const handlePageChange = (number) => {
    ResetAffichage(number);
    props.methodPagination && props.methodPagination();
  };

  const handlePageNext = (number) => {
    if (pageActuelle < number) {
      ResetAffichage(pageActuelle + 1);
      props.methodPagination && props.methodPagination();
    }
  };
  //#endregion

  //#endregion

  //#region Component

  //#region Headers

  /**
   *
   * @returns Les en-têtes de la table
   */
  const TableHeaders = () => {
    return (
      <thead className="m-2 row-height">
        <tr>
          {props.Headers.map((header, i) => {
            return <TableHeader key={i} header={header} />;
          })}
        </tr>
      </thead>
    );
  };

  /**
   *
   * @param {*} header
   * @returns Une en-tête
   */
  const TableHeader = ({ header }) => {
    return header.filter.isFilter ? (
      <TableHeaderCellFilter header={header} />
    ) : header.fieldname === TAGSELECTION ? (
      <TableHeaderCellSelection header={header} />
    ) : (
      <TableHeaderCell header={header} />
    );
  };

  //#region HeaderCells

  function GetHeaderColSpan(fieldname) {
    return props.Cells.filter((c) => {
      return c.fieldname === fieldname;
    }).length;
  }

  const TableHeaderCell = ({ header }) => {
    return (
      <th key={header.fieldname} colSpan={GetHeaderColSpan(header.fieldname)}>
        <div className="row-height">
          {header.caption ? header.caption : header.fieldname}
        </div>
      </th>
    );
  };

  const TableHeaderCellSelection = ({ header }) => {
    const HandleClick = () => {
      setArraySelector([]);
    };

    return (
      <th key={header.fieldname} colSpan={GetHeaderColSpan(header.fieldname)}>
        <div className="row-height">
          {header.caption ? header.caption : header.fieldname}
          <FontAwesomeIcon
            onClick={HandleClick}
            // onDoubleClick={HandleDoubleClick}
            icon={faClose}
            className={"icon-bt"}
          />
        </div>
      </th>
    );
  };

  const TableHeaderCellFilter = ({ header }) => {
    const [showPopover, setShowPopover] = useState(false);
    return (
      <th key={header.fieldname}>
        <div className="row-height th-with-icon">
          {header.caption ? header.caption : header.fieldname}
          <OverlayTrigger
            trigger="click"
            rootClose
            show={showPopover}
            onToggle={(isOpen) => setShowPopover(isOpen)}
            overlay={PopoverFilter(header.fieldname, setShowPopover)}
            placement="bottom"
          >
            <Filter
              className={`icon-bt ${IsButtonShouldBeCheck(header.fieldname) ? "filter-actif" : ""} ${showPopover ? "filter-open" : ""}`}
            />

          </OverlayTrigger>
        </div>
      </th>
    );
  };

  const PopoverFilter = (fieldname, setShowPopover) => {
    let _arFilters = [];
    // console.log(props.Data.Count)
    // if ((props.Data) || (props.Data && props.Data.Count === 0)) {
    // console.log(props.Data);
    if ((props.Data && props.Data.length === 0)) {
      _arFilters = [];
    } else {
      if(props.Data.length > 1)
      {
        _arFilters = Object.entries(groupBy(props.Data, fieldname));
      }

    }
    const _arrayVal = _arFilters.map((x) => x[0]);

    const _headerToApply = props.Headers.find((h) => h.fieldname === fieldname);

    //#region check

  const [arrayFilterIn, setArrayFilterIn] = useState(JSON.parse(JSON.stringify(arrayFilter)));

    function IsFiltercheckboxShouldBeCheck(fieldname, item) {

      if (
        arrayFilterIn.findIndex(
          (filter) => filter.fieldname === fieldname && filter.item === item
        ) > -1
      )
        return true;
      return false;
    }

    const HandleCheckfilterChange = (checked, key, value) => {
      // let _arrTemp = JSON.parse(JSON.stringify(arrayFilter));
      let _arrTemp = JSON.parse(JSON.stringify(arrayFilterIn));

      if (checked) {
        _arrTemp.push({ fieldname: key, item: value });
        // setArrayFilter(_arrTemp);
        setArrayFilterIn(_arrTemp);
      } else {
        const index = _arrTemp.findIndex(
          (filter) => filter.fieldname === key && filter.item === value
        );
        if (index > -1) {
          _arrTemp.splice(index, 1);
          // setArrayFilter(_arrTemp);
          setArrayFilterIn(_arrTemp);
        }
      }
    };

  const HandleCheckFilterClick=e => {
    let _arrTemp = JSON.parse(JSON.stringify(arrayFilterIn));
    setArrayFilter(_arrTemp);
  }

    //#endregion

    //#region RangeDate

    let _arrayDate = _arrayVal.map((date) => {
      if (!date) return date;
      try {
        var dateRegex = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/;

        let _match = RegexTestAndReturnMatch(date, dateRegex);

        if (_match === date) {
          dateRegex = /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/;
          let _match2 = RegexTestAndReturnMatch(date, dateRegex);

          let _retu = new Date(
            _match2.substring(0, 4),
            _match2.substring(5, 7) - 1,
            _match2.substring(8, 10)
          );

          return _retu;
        }

        let _retu = new Date(
          _match.substring(6),
          _match.substring(3, 5) - 1,
          _match.substring(0, 2)
        );

        return _retu;
      } catch (error) {
        return date;
      }
    });

    const minDate = new Date(Math.min.apply(null, _arrayDate));
    const maxDate = new Date(Math.max.apply(null, _arrayDate));

    const ParseDateFormat = (text) => {
      function parseAvecSlash() {
        var dateRegex = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/;
        let _match = text.match(dateRegex)[0];

        return `${_match.substring(6)}-${_match.substring(
          3,
          5
        )}-${_match.substring(0, 2)}`;
      }

      function parseAvecTiret() {
        var dateRegex = /^[0-9]{1,2}-[0-9]{1,2}-[0-9]{4}/;
        let _match = text.match(dateRegex)[0];

        return `${_match.substring(6)}-${_match.substring(
          3,
          5
        )}-${_match.substring(0, 2)}`;
      }

      try {
        let _match = parseAvecSlash();
        if (_match === text) {
          _match = parseAvecTiret();
        }

        return _match;
      } catch {
        return text;
      }
    };

    const GetTimeFromTextDateParsed = (text) => {
      try {
        var dateRegex = /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/g;

        let _match = text.match(dateRegex)[0];

        let _retu = new Date(
          _match.substring(0, 4),
          _match.substring(5, 7) - 1,
          _match.substring(8)
        );
        return _retu.getTime();
      } catch {
        return text;
      }
    };

    const [minDateValue, setMinDateValue] = useState(
      arrayFilterRangeDate.find((f) => f.fieldname === fieldname)
        ? arrayFilterRangeDate.find((f) => f.fieldname === fieldname).min
        : ParseDateFormat(minDate.toLocaleDateString("fr-FR"))
    );

    const [maxDateValue, setMaxDateValue] = useState(
      arrayFilterRangeDate.find((f) => f.fieldname === fieldname)
        ? arrayFilterRangeDate.find((f) => f.fieldname === fieldname).max
        : ParseDateFormat(maxDate.toLocaleDateString("fr-FR"))
    );

    const HandleMinDateValueChanged = (e) => {
      e.preventDefault();
      setMinDateValue(e.target.value);
    };

    const HandleMinDateRangeValueChanged = (e) => {
      e.preventDefault();
      setMinDateValue(
        ParseDateFormat(
          new Date(Number(e.target.value)).toLocaleDateString("us-US")
        )
      );
    };

    const HandleMaxDateValueChanged = (e) => {
      e.preventDefault();
      setMaxDateValue(e.target.value);
    };

    const HandleMaxDateRangeValueChanged = (e) => {
      e.preventDefault();
      setMaxDateValue(
        ParseDateFormat(
          new Date(Number(e.target.value)).toLocaleDateString("us-US")
        )
      );
    };

    const HandleFilterDateClick = () => {
      let _obj = { fieldname: fieldname, min: minDateValue, max: maxDateValue };
      let _arrayFilterDate = JSON.parse(JSON.stringify(arrayFilterRangeDate));
      let _index = _arrayFilterDate.findIndex((f) => f.fieldname === fieldname);
      if (_index > -1) {
        _arrayFilterDate[_index] = _obj;
      } else {
        if (
          new Date(minDateValue).getTime() !== minDate.getTime() ||
          new Date(maxDateValue).getTime() !== maxDate.getTime()
        ) {
          _arrayFilterDate.push(_obj);
        }
      }
      setArrayFilterRangeDate(_arrayFilterDate);
    };

    //#endregion

    //#region Range
    const minVal = _arrayVal.some(isNaN) ? undefined : Math.min(..._arrayVal);
    const maxVal = _arrayVal.some(isNaN) ? undefined : Math.max(..._arrayVal);
    const [minValue, setMinvalue] = useState(
      arrayFilterSeuis.find((f) => f.fieldname === fieldname)
        ? arrayFilterSeuis.find((f) => f.fieldname === fieldname).min
        : minVal
    );
    const [maxValue, setMaxValue] = useState(
      arrayFilterSeuis.find((f) => f.fieldname === fieldname)
        ? arrayFilterSeuis.find((f) => f.fieldname === fieldname).max
        : maxVal
    );

    const HandleMinValueChanged = (e) => {
      e.preventDefault();
      setMinvalue(e.target.value);
    };

    const HandleMaxValueChanged = (e) => {
      setMaxValue(e.target.value);
    };

    const HandleFilterSeuilClick = () => {
      let _obj = { fieldname: fieldname, min: minValue, max: maxValue };
      let _arrayFilterSeuis = JSON.parse(JSON.stringify(arrayFilterSeuis));
      let _index = _arrayFilterSeuis.findIndex(
        (f) => f.fieldname === fieldname
      );

      if (_index > -1) {
        _arrayFilterSeuis[_index] = _obj;
      } else {
        if (minValue !== minVal || maxValue !== maxVal) {
          _arrayFilterSeuis.push(_obj);
        }
      }
      setArrayFilterSeuils(_arrayFilterSeuis);
    };

    //#endregion

    //#region Search
    const _arrSearch = JSON.parse(JSON.stringify(arraySearch));
    const [searchCol, setSearchCol] = useState(
      _arrSearch.find((s) => s.fieldname === fieldname)
        ? _arrSearch.find((s) => s.fieldname === fieldname).text
        : ""
    );

    const handleSearchOnChange = (e) => {
      setSearchCol(e.target.value);
    };

    const HandleSearchOnClick = () => {
      let _index = _arrSearch.findIndex((f) => f.fieldname === fieldname);
      let _obj = { fieldname: fieldname, text: searchCol };

      if (searchCol.length === 0) {
        if (_index > -1) {
          _arrSearch.pop(_index);
        }
      } else {
        if (_index > -1) {
          _arrSearch[_index] = _obj;
        } else {
          _arrSearch.push(_obj);
        }
      }
      setArraySearch(_arrSearch);
      ResetAffichage(1);
    };

    //#endregion


    const ResetFilterCol = () => {
      function removeValue(array, setArray) {
        let _array = JSON.parse(JSON.stringify(array));
        _array = _array.filter((f) => f.fieldname !== fieldname);
        setArray(_array);
      }
      removeValue(arrayFilter, setArrayFilter);
      removeValue(arrayFilterRangeDate, setArrayFilterRangeDate);
      removeValue(arrayFilterSeuis, setArrayFilterSeuils);
      removeValue(arraySearch, setArraySearch);

    };

    const ClosePopover = () => {
      setShowPopover(false);
    };

    if (_headerToApply.filter.isCheckbox && _arFilters.length >= 20) {
      _headerToApply.filter.isCheckbox = false;
    }
    return (
      <Popover className="popover-filters">
        <Tabs
          fill
          defaultActiveKey={
            Object.entries(_headerToApply.filter).find(
              (value) => value[0] !== "isFilter" && value[1]
            )[0]
          }
        >
          {/* Checkbox */}
          {_headerToApply.filter.isCheckbox && (
            <Tab title="Valeur" eventKey={"isCheckbox"}>
              <div id="ppvr-check">
                {_arFilters.map((item, index) => {
                  if (item[0] === "undefined") return null;
                  return (
                    <Form.Check
                      id={`ppvr-check-${index}`}
                      key={index}
                      type="checkbox"
                      checked={IsFiltercheckboxShouldBeCheck(
                        fieldname,
                        item[0]
                      )}
                      label={
                        _headerToApply.editor
                          ? _headerToApply.editor(item[0])
                          : item[0]
                      }
                      onChange={(e) =>
                        HandleCheckfilterChange(
                          e.target.checked,
                          fieldname,
                          item[0]
                        )
                      }
                    />
                  );
                })}
                 <Button className="btn-filter" onClick={HandleCheckFilterClick}>Valider</Button>
              <Button
                className="btn-filter cancel"
                onClick={() => {
                  ResetFilterCol();
                }}
              >Effacer
              </Button>

              </div>
            </Tab>
          )}
          {/* Date du au */}
          {_headerToApply.filter.isRangeDate && (
            <Tab title="Date" eventKey={"isRangeDate"}>
              <div id="ppvr-rangeDate">
                <Col>
                  <Form.Label>Du</Form.Label>
                  <Form.Control
                    type="date"
                    value={minDateValue}
                    onChange={HandleMinDateValueChanged}
                  />

                  <Form.Range
                    min={minDate && minDate.getTime()}
                    max={maxDate && maxDate.getTime()}
                    value={GetTimeFromTextDateParsed(minDateValue)}
                    onChange={HandleMinDateRangeValueChanged}
                  />
                </Col>
                <Col>
                  <Form.Label>Au</Form.Label>
                  <Form.Control
                    type="date"
                    value={maxDateValue}
                    onChange={HandleMaxDateValueChanged}
                  />
                  <Form.Range
                    min={minDate && minDate.getTime()}
                    max={maxDate && maxDate.getTime()}
                    value={GetTimeFromTextDateParsed(maxDateValue)}
                    onChange={HandleMaxDateRangeValueChanged}
                  />
                </Col>
              </div>
              <Button className="btn-filter" onClick={HandleFilterDateClick}>Valider</Button>
              <Button
                className="btn-filter cancel"
                onClick={() => {
                  ResetFilterCol();
                }}
              >Effacer
                <FilterReset title="Réinitialiser les filtres" />
              </Button>

            </Tab>
          )}
          {/* Num max min */}
          {!_arrayVal.some(isNaN) && _headerToApply.filter.isRange && (
            <Tab title="Seuils" eventKey={"isRange"}>
              <div id="ppvr-range">
                <Col>
                  <Form.Label>Minimum</Form.Label>
                  <Form.Control
                    type="number"
                    value={minValue}
                    onChange={HandleMinValueChanged}
                  />
                  <Form.Range
                    min={minVal}
                    max={maxVal}
                    value={minValue}
                    onChange={(e) => setMinvalue(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>Maximum</Form.Label>
                  <Form.Control
                    type="number"
                    value={maxValue}
                    onChange={HandleMaxValueChanged}
                  />
                  <Form.Range
                    min={minVal}
                    max={maxVal}
                    value={maxValue}
                    onChange={(e) => setMaxValue(e.target.value)}
                  />
                </Col>
              </div>
              <Button className="btn-filter validate" onClick={HandleFilterSeuilClick}>Valider</Button>
              <Button
                className="btn-filter cancel"
                onClick={() => {
                  ResetFilterCol();
                }}
              >Effacer
                <FilterReset title="Réinitialiser les filtres" />
              </Button>

            </Tab>
          )}
          {/* Recherche sur cette colonne */}
          {_headerToApply.filter.isSearchCol && (
            <Tab title="Recherche" eventKey={"isSearchCol"}>
              <div id="ppvr-search">
                <InputGroup className="mb-3">
                  <Form.Control
                    type="search"
                    placeholder="Recherchez..."
                    value={searchCol}
                    onChange={handleSearchOnChange}
                  />

                  <Button
                    onClick={HandleSearchOnClick}
                    id="button-addon2"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </InputGroup>
              </div>
            </Tab>
          )}

          <Tab
            title={
              <span className="remove-filter">
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={ClosePopover}
                />
              </span>
            }
          />
        </Tabs>
      </Popover>
    );
  };

  //#endregion

  //#endregion

  //#region Body

  /**
   *
   * @returns Le corps de la table
   */
  const TableBody = () => {
    if (!Data().length || Data().length === 0)
      return (
        <tbody>
          <tr>
            <td colSpan={props.Headers.length}>{props.IsUser ? "Utilisez la barre de recherche." : "Aucune donnée"}</td>
          </tr>
        </tbody>
      );

    let nombreAffiche = nbParPages * -1 * (pageActuelle - 1);

    return (
      <tbody>
        {Data().map((item, i) => {
          if (nombreAffiche >= nbParPages || nombreAffiche < 0) {
            nombreAffiche += 1;
            return null;
          }
          nombreAffiche += 1;

          return <TableBodyRow key={i} index={i} item={item} />;
        })}
      </tbody>
    );
  };

  /**
   *
   * @param {*} item
   * @returns Une ligne de la table
   */
  const TableBodyRow = ({ item, index }) => {
    return (
      <tr
        className={
          index === rowIndexSelected || arraySelector.includes(index) || (ClientSiteCt.storedClientSite && item.GUID && item.GUID === ClientSiteCt.storedClientSite.GUID)
            ? "table-presta-row-selected"
            : ""
        }
      >
        {props.Headers.map((header, i) => {
          return (
            <TableBodyCell
              key={i}
              fieldname={header.fieldname}
              value={item[header.fieldname]}
              index={index}
            />
          );
        })}
      </tr>
    );
  };

  const handleTdClick = (index, _cellToApply, item) => {
    if (_cellToApply.isSelectable) {
      setRowIndexSelected(index);
      SwitchTagMethod(_cellToApply.tagMethod, item, index);
    }
  };

  /**
   *
   * @param {*} {fieldname, value }
   * @returns Une cellule de la table
   */
  const TableBodyCell = ({ fieldname, value, index }) => {
    // Je recherche la cell a appliquer avec le même fieldname, qui contient les informations nécessaire à la création de la cellule

    const _cellToApplys = props.Cells.filter((c) => {
      return c.fieldname === fieldname;
    });

    if (_cellToApplys.length <= 0) {
      return <td></td>;
    }
    return _cellToApplys.map((_cellToApply, i) => {
      return (
        <TableBodyCellBody
          key={i}
          _cellToApply={_cellToApply}
          value={value}
          index={index}
        />
      );
    });
  };

  const TableBodyCellBody = ({ _cellToApply, value, index }) => {
    let _textFinal = value;

    //Marquage par l'editor
    _textFinal = _cellToApply.editor
      ? _cellToApply.editor(_textFinal, index, SwitchTagMethod)
      : _textFinal;

    //Marquage en <mark></mark>
    _textFinal = _cellToApply.isSearchable
      ? HighlightTextIfSearch(_textFinal)
      : _textFinal;

    // Marquage en h1
    _textFinal = _cellToApply.isH1 ? <h1> {_textFinal} </h1> : _textFinal;

    return (
      <td
        style={_cellToApply.fixedWidth && { width: _cellToApply.fixedWidth }}
        onClick={() => handleTdClick(index, _cellToApply, value)}
      >
        {_textFinal}
      </td>
    );
  };

  //#endregion

  //#region Placeholder

  const PlaceHolderTableLine = ({ numberOfLines }) => {
    let _arrayLoading = [];
    for (let index = 0; index < numberOfLines; index++) {
      _arrayLoading.push(index + 1);
    }
    return _arrayLoading.map((i) => {
      return (
        <tbody key={i}>
          <tr>
            <td colSpan={props.Headers.length}>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={12} />
              </Placeholder>
            </td>
          </tr>
        </tbody>
      );
    });
  };

  //#endregion

  //#region Pagination
  const LeftArrow = () => (
    <svg width="30" height="10" viewBox="0 0 30 10" fill="none">
      <line x1="30" y1="5" x2="5" y2="5" stroke="#01B075" strokeWidth="1" />
      <line x1="5" y1="5" x2="10" y2="2" stroke="#01B075" strokeWidth="1" />
      <line x1="5" y1="5" x2="10" y2="8" stroke="#01B075" strokeWidth="1" />
    </svg>
  );
  const RightArrow = () => (
    <svg width="30" height="10" viewBox="0 0 30 10" fill="none">
      <line x1="0" y1="5" x2="25" y2="5" stroke="#01B075" strokeWidth="1" />
      <line x1="25" y1="5" x2="20" y2="2" stroke="#01B075" strokeWidth="1" />
      <line x1="25" y1="5" x2="20" y2="8" stroke="#01B075" strokeWidth="1" />
    </svg>
  );

  const TablePagination = () => {
    let _items = [];

    const totalData = Data().length;
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const pageName = pathSegments[pathSegments.length - 1] || "Accueil";

    let _lData = Data();
    let _limiter = _lData.length;
    let _isEllipsisNedded = _limiter / nbParPages + 1 > 10;

    _items.push(
      <Pagination.Prev key="prev" onClick={() => handlePagePrev()} className="m-1">
        <LeftArrow />
      </Pagination.Prev>
    );

    const maxLoop = Math.ceil(_limiter / nbParPages);
    // for (let number = 1; number <= _limiter / nbParPages + 1; number++) {
    for (let number = 1; number <= maxLoop; number++) {
      if (_isEllipsisNedded) {
        if (number === 1) {
          // 1
          _items.push(
            <Pagination.Item
              key={number}
              active={number === pageActuelle}
              onClick={() => handlePageChange(number)}
              className="m-1"
            >
              {number}
            </Pagination.Item>
          );

          if (pageActuelle === 1) {
            //x + 1
            if (number + 1 < _limiter / nbParPages + 1) {
              _items.push(
                <Pagination.Item
                  key={number + 1}
                  active={number + 1 === pageActuelle}
                  onClick={() => handlePageChange(number + 1)}
                  className="m-1"
                >
                  {number + 1}
                </Pagination.Item>
              );
            }

            //x + 2
            if (number + 2 < _limiter / nbParPages + 1) {
              _items.push(
                <Pagination.Item
                  key={number + 2}
                  active={number + 2 === pageActuelle}
                  onClick={() => handlePageChange(number + 2)}
                  className="m-1"
                >
                  {number + 2}
                </Pagination.Item>
              );
            }

            //Elispsis
            if (number + 3 < _limiter / nbParPages + 1) {
              _items.push(
                <Pagination.Ellipsis className="m-1" key={number + 3} />
              );
            }
            continue;
          }
        }

        if (number + 1 > _limiter / nbParPages + 1) {
          if (pageActuelle === number) {
            //Elipsis
            if (number - 3 > 1) {
              _items.push(
                <Pagination.Ellipsis className="m-1" key={number - 3} />
              );
            }

            //x - 2
            if (number - 2 > 1) {
              _items.push(
                <Pagination.Item
                  key={number - 2}
                  active={number - 2 === pageActuelle}
                  onClick={() => handlePageChange(number - 2)}
                  className="m-1"
                >
                  {number - 2}
                </Pagination.Item>
              );
            }

            // x - 1
            if (number - 1 > 1) {
              _items.push(
                <Pagination.Item
                  key={number - 1}
                  active={number - 1 === pageActuelle}
                  onClick={() => handlePageChange(number - 1)}
                  className="m-1"
                >
                  {number - 1}
                </Pagination.Item>
              );
            }
          }

          _items.push(
            <Pagination.Item
              key={number}
              active={number === pageActuelle}
              onClick={() => handlePageChange(number)}
              className="m-1"
            >
              {number}
            </Pagination.Item>
          );
          continue;
        }

        if (number === pageActuelle) {
          //Elipsis
          if (number - 3 > 1) {
            _items.push(
              <Pagination.Ellipsis className="m-1" key={number - 3} />
            );
          }

          //x - 2
          if (number - 2 > 1) {
            _items.push(
              <Pagination.Item
                key={number - 2}
                active={number - 2 === pageActuelle}
                onClick={() => handlePageChange(number - 2)}
                className="m-1"
              >
                {number - 2}
              </Pagination.Item>
            );
          }

          // x - 1
          if (number - 1 > 1) {
            _items.push(
              <Pagination.Item
                key={number - 1}
                active={number - 1 === pageActuelle}
                onClick={() => handlePageChange(number - 1)}
                className="m-1"
              >
                {number - 1}
              </Pagination.Item>
            );
          }

          //x
          _items.push(
            <Pagination.Item
              key={number}
              active={number === pageActuelle}
              onClick={() => handlePageChange(number)}
              className="m-1"
            >
              {number}
            </Pagination.Item>
          );

          //x + 1
          if (number + 1 < _limiter / nbParPages) {
            _items.push(
              <Pagination.Item
                key={number + 1}
                active={number + 1 === pageActuelle}
                onClick={() => handlePageChange(number + 1)}
                className="m-1"
              >
                {number + 1}
              </Pagination.Item>
            );
          }

          //x + 2
          if (number + 2 < _limiter / nbParPages) {
            _items.push(
              <Pagination.Item
                key={number + 2}
                active={number + 2 === pageActuelle}
                onClick={() => handlePageChange(number + 2)}
                className="m-1"
              >
                {number + 2}
              </Pagination.Item>
            );
          }

          //Elispsis
          if (number + 3 < _limiter / nbParPages) {
            _items.push(
              <Pagination.Ellipsis className="m-1" key={number + 3} />
            );
          }

          continue;
        }
      } else {
        _items.push(
          <Pagination.Item
            key={number}
            active={number === pageActuelle}
            onClick={() => handlePageChange(number)}
            className="m-1"
          >
            {number}
          </Pagination.Item>
        );
      }
    }

    _items.push(
      <Pagination.Next key="next" onClick={() => handlePageNext(totalData / nbParPages)} className="m-1">
        <RightArrow />
      </Pagination.Next>
    );

    return (
      <Stack direction="horizontal" className="content-pagination">
        <div className="total-data">{totalData} {pageName} au total</div>
        <Pagination className="m-2">{_items}</Pagination>
        <DrodpdownNbPages />
      </Stack>
    );
  };

  const DrodpdownNbPages = () => {
    return (
      <DropdownButton
        variant=""
        className="button-periode"
        drop="down-centered"
        style={{ borderRadius: "10px" }}
        title={`Résultat par page : ${nbParPages}`}
      >
        <Dropdown.Item
          onClick={() => {
            setNbParPages(10);
            setPageActuelle(1);
          }}
        >
          10 / page
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            setNbParPages(20);
            setPageActuelle(1);
          }}
        >
          20 / page
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            setNbParPages(50);
            setPageActuelle(1);
          }}
        >
          50 / page
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            setNbParPages(100);
            setPageActuelle(1);
          }}
        >
          100 / page
        </Dropdown.Item>
      </DropdownButton>
    );
  };

  //#endregion

  //#region Selection

  const SelectionInfo = () => {
    const containerRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
      const handleScroll = () => {
        if (containerRef.current) {
          // const rect = containerRef.current.getBoundingClientRect();
          setIsSticky(window.scrollY > 100);
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Met à jour isSticky quand un document est sélectionné
    useEffect(() => {
      if (arraySelector.length > 0) {
        if (window.scrollY > 100) {
          setIsSticky(true);
        }
      } else {
        setIsSticky(false);
      }
      //eslint-disable-next-line
    }, [arraySelector.length]);

    const SwitchTagSelection = async (tagMethod) => {
      switch (tagMethod) {
        case "selection_factures":
          await HandleSelectorFacture();

          break;

        default:
          break;
      }
    };

    const HandleTelechargerSelection = async () => {
      let _tagMethod = props.Cells.find(
        (c) => c.fieldname === TAGSELECTION
      ).tagMethod;
      await SwitchTagSelection(_tagMethod);
    };

    if (arraySelector.length > 0) {
      return (
        <Container ref={containerRef} className={`download-container ${isSticky ? "is-sticky" : ""}`}>
          <Button
            onClick={HandleTelechargerSelection}
            className="btn-upload-file"
          >
            <FontAwesomeIcon icon={faDownload} className="mr-2" />
            Télécharger {arraySelector.length} document
            {arraySelector.length > 1 && "s"}
          </Button>
        </Container>
      );
    }
    return "";
  };

  //#endregion

  //#region TopPannel

  const TopPannel = () => {

    return (
      <Row className="mb-2 content-search">
        {props.TopPannelLeftToSearch && props.TopPannelLeftToSearch}
        <Col className="m-1 search-bar">
          <Form.Control
            id="search-bar-table-data"
            type="search"
            placeholder="Rechercher dans la liste..."
            aria-label="Search"
            onChange={(e) => {
              handleSearch(e);
            }}
            className="noBorder"
            value={search}
          />
        </Col>
        {props.ButtonFilters && (
          <Col className="m-1 status-bar" md={"auto"}>
            <div className="project-sort-nav">
              <nav>
                <ul>
                  <ButtonFilter />
                  {props.ButtonFilters.map((filter, index) => {
                    return <ButtonFilter key={index} filter={filter} />;
                  })}
                </ul>
              </nav>
            </div>
          </Col>
        )}
        {props.TopPannelRightToSearch && props.TopPannelRightToSearch}
        {props.Headers.findIndex((h) => h.fieldname.includes(TAGSELECTION)) >
          -1 && (
            <Col md={"auto"} className="m-1">
              <SelectionInfo />
            </Col>
          )}
      </Row>
    );
  };

  //#region Bouton filtres

  const ButtonFilter = ({ filter }) => {
    if (!filter) {
      return (
        <>
          <span className="filter-status-label">Etat :</span>
          <li
            className={btFilterActif ? "li-inactif" : "li-actif"}
            onClick={() => handleTousFilter()}
          >
            Tous
          </li>
        </>
      );
    }

    return (
      <li
        className={isFilterActive(filter) ? "li-actif" : "li-inactif"}
        onClick={() => handleFilterClick(filter)}
      >
        {filter.editor ? filter.editor(filter.value) : filter.value}
      </li>
    );
  };

  //#endregion

  //#endregion

  //#endregion

  //#endregion

  //#region SMALL

  const PlaceholderCardPrestation = (numberOfCards) => {
    let _arrayLoading = [];
    for (let index = 0; index < numberOfCards; index++) {
      _arrayLoading.push(index + 1);
    }

    return _arrayLoading.map((p) => {
      return (
        <Card className="m-2" key={p}>
          <Card.Title>
            <Col>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={6} />
              </Placeholder>
            </Col>
          </Card.Title>
          <Card.Subtitle>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={4} />
            </Placeholder>
          </Card.Subtitle>

          <Card.Body>
            <h6>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={6} />
              </Placeholder>
            </h6>
            <h6>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={6} />
              </Placeholder>
            </h6>
            <h6>
              <Placeholder as="p" animation="glow">
                <Placeholder xs={6} />
              </Placeholder>
            </h6>
          </Card.Body>
        </Card>
      );
    });
  };

  const GridCards = () => {
    if (!props.CardModel) {
      return (<Row>
        <Col>
          <Table className="table-presta">
            <TableHeaders />
            {props.IsLoaded ? (
              <TableBody />
            ) : (
              <PlaceHolderTableLine
                numberOfLines={
                  props.placeholdeNbLine ? props.placeholdeNbLine : 5
                }
              />
            )}
          </Table>
        </Col>
      </Row>)


    }


    if (!props.IsLoaded)
      return PlaceholderCardPrestation(
        props.placeholdeNbLine ? props.placeholdeNbLine : 5
      );

    let nombreAffiche = nbParPages * -1 * (pageActuelle - 1);
    return (
      <div>
        {Data().map((item, index) => {
          if (nombreAffiche >= nbParPages || nombreAffiche < 0) {
            nombreAffiche += 1;
            return null;
          }
          nombreAffiche += 1;
          return (
            <div key={index}>
              <GridCard item={item.unboundColonne} />
            </div>
          );
        })}
      </div>
    );
  };

  const GridCard = ({ item }) => {
    return (
      <Card className="m-2 p-1">
        <GridCardHeader item={item} />
        <GridCardBody item={item} />
      </Card>
    );
  };

  const GridCardHeader = ({ item }) => {
    return (
      <>
        <Card.Title>{props.CardModel.header.title.editor(item)}</Card.Title>
        <Card.Subtitle>
          {props.CardModel.header.subtitle.editor &&
            props.CardModel.header.subtitle.editor(item)}
        </Card.Subtitle>
      </>
    );
  };

  const GridCardBody = ({ item }) => {
    return <Card.Body>{props.CardModel.body.editor(item)}</Card.Body>;
  };

  //#endregion

  //#region Specifique

  const ModalList = () => {
    const PrestaCtx = useContext(PrestaContext);
    if (!PrestaCtx) return null;



    return (
      <>
        {PrestaCtx.isInterventions ? (
          <ModalFactures />
        ) : (
          <>
            <ModalListeTaches />
            <ModalDocuments />
          </>
        )}
      </>
    );
  };


  const SwitchTagMethod = (tagMethod, item, index) => {
    switch (tagMethod) {
      case "tagListeTaches":
        HandleShowModalListeTaches(item);
        break;
      case "tagListeDocuments":
        HandleAfficherDocuments(item);
        break;
      case "tagInterventionDocuments":
        HandleAfficherFacture(Data()[index]);
        break;
      case "tagListeSite":
        HandleChoixDuSite(Data()[index]);
        break;
      default:
        if (tagMethod && tagMethod.includes("selection_")) {
          let _arrSelector = JSON.parse(JSON.stringify(arraySelector));
          if (_arrSelector.includes(index)) {
            _arrSelector = _arrSelector.filter((s) => s !== index);
          } else {
            _arrSelector.push(index);
          }
          if (!_arrSelector) {
            _arrSelector = [];
          }
          setArraySelector(_arrSelector);
        }
        break;
    }
  };


  //#region Liste des sites

  const HandleChoixDuSite = (siteAChoisir) => {
    //Pas de changement si même site
    let _actualClientSite = ClientSiteCt.storedClientSite;
    if (!(_actualClientSite) || (_actualClientSite.GUID !== siteAChoisir.GUID)) {
      ClientSiteCt.setClientSite(siteAChoisir);
      navigate("/");
    }
  }


  //#endregion


  //#region Prestation contrat

  const PrestaCtx = useContext(PrestaContext);

  //#region Liste des taches
  const [showModalListeTaches, setShowModalListeTaches] = useState(false);
  const [isLoadingTaches, setIsLoadingTaches] = useState(false);
  const [listeTaches, setListeTaches] = useState([]);
  const [prestaName, setPrestaName] = useState("");

  const HandleShowModalListeTaches = async (presta) => {
    //Récupère les données
    if (isLoadingTaches) return;
    setPrestaName(presta.DescriptionPrestationContrat);
    setIsLoadingTaches(true);
    setShowModalListeTaches(true);

    await GetPrestationReleveTache(
      tokenCt,
      presta.IdPrestationContrat,
      FetchSetListeTache
    );
  };

  const FetchSetListeTache = (data) => {
    if (data.length) {
      const groups = data.reduce((groups, item) => {
        const k = groups[item.k] || [];
        k.push(item);
        groups[item.k] = k;
        return groups;
      }, {});

      const arr = [];
      Object.keys(groups).forEach((key) =>
        arr.push({ name: key, value: groups[key] })
      );

      setListeTaches(arr);
      setShowModalListeTaches(true);
      setIsLoadingTaches(false);
    } else {
      const arr = [];

      arr.push({ name: data.k, value: data.v });

      setListeTaches(arr);
      setShowModalListeTaches(true);
      setIsLoadingTaches(false);
    }
  };

  const ModalListeTaches = () => {
    const modalBodyRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    //eslint-disable-next-line
    const [isAtTop, setIsAtTop] = useState(true);

    useEffect(() => {
      const checkScrollability = () => {
        if (modalBodyRef.current) {
          const { scrollHeight, clientHeight } = modalBodyRef.current;

          if (scrollHeight > clientHeight) {
            setIsScrollable(true);
          } else {
            setIsScrollable(false);
          }
        }
      };
      const handleScroll = () => {
        if (modalBodyRef.current) {
          const { scrollTop } = modalBodyRef.current;

          if (scrollTop > 0) {
            modalBodyRef.current.classList.add("no-scroll-indicator");
            setIsAtTop(false);
          } else {
            modalBodyRef.current.classList.remove("no-scroll-indicator");
            setIsAtTop(true);
          }
        }
      };

      checkScrollability();

      if (modalBodyRef.current) {
        modalBodyRef.current.addEventListener("scroll", handleScroll);
      }

      window.addEventListener("resize", checkScrollability);

      return () => {
        if (modalBodyRef.current) {
          // eslint-disable-next-line
          modalBodyRef.current.removeEventListener("scroll", handleScroll);
        }
        window.removeEventListener("resize", checkScrollability);
      };
      // eslint-disable-next-line
    }, [listeTaches]);

    const scrollToBottom = () => {
      if (modalBodyRef.current) {
        modalBodyRef.current.scrollTo({
          top: modalBodyRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };

    const CardListeTachesBodyL = () => {
      if (isLoadingTaches)
        return (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        );
      if (listeTaches.length === 0) return <div>Aucune tâche enregistrée</div>;

      let _body = (
        <div>
          {listeTaches.map((Relevetache, index) => {
            return (
              <span key={index} className="mb-2">
                <Row>
                  <Col className="task-statement">
                    {Relevetache.name}
                  </Col>
                </Row>
                {ClientSiteCt.storedClientSite.DroitMaintenanceReleveTache && (Array.isArray(Relevetache.value) ? (
                  Relevetache.value.map((tache, indexT) => {
                    return (
                      <Row key={indexT}>
                        <Col className="task">
                          {/* <Form.Check
                            readOnly
                            checked={false}
                            label={tache.v}
                          /> */}
                          {tache.v}
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <Row>
                    <Col className="task">
                      {/* { <Form.Check
                        readOnly
                        checked={false}
                        label={Relevetache.value}
                      />} */}
                      {Relevetache.value}
                    </Col>
                  </Row>
                ))}
              </span>
            );
          })}
        </div>
      );

      return _body;
    };

    return (
      <Modal
        dialogClassName="modal-listing"
        show={showModalListeTaches || PrestaCtx.showModalTaches}
        onHide={() => {
          setShowModalListeTaches(false);
          PrestaCtx.setShowModalTache(false);
        }}
        backdrop="static"
        keyboard={false}
        animation={false}
      >
        <Modal.Header>
          <Modal.Title>
            <FontAwesomeIcon icon={faTasks} />
            Liste des relevés de tâches
            <div className="modal-title h6" > {prestaName} </div>
          </Modal.Title>
          <Button
            className="close-modal"
            onClick={() => setShowModalListeTaches(false)}
          ><FontAwesomeIcon icon={faXmark} />
          </Button>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef} className={`modal-body ${isScrollable ? "scrollable" : ""}`}>
          <CardListeTachesBodyL />
          {isScrollable && (
            <button onClick={scrollToBottom} className="scroll-modal">
              <FontAwesomeIcon icon={faArrowDown} size="lg" />
            </button>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  //#endregion

  useEffect(() => {
    if (PrestaCtx) {
      if (PrestaCtx.showModalTaches) {
        HandleShowModalListeTaches(PrestaCtx.prestaSelected);
      }
    }
    // eslint-disable-next-line
  }, [PrestaCtx && PrestaCtx.showModalTaches]);


  //#region Documents

  // const [gridColMDValue, setGridColMDValue] = useState(12);
  // const CardDocs = () => {
  //   // const _arrayDocs = JSON.parse(JSON.stringify(documents));
  //   const _arrayDocs = documents;

  //   return (
  //     <Card className="mb-2">
  //       <Card.Header className="card-document">
  //         <Row>
  //           <Col md={"auto"}>
  //             Documents{" "}
  //             {isDocumentLoaded ? (
  //               `(${_arrayDocs.length > 1
  //                 ? _arrayDocs.length - 1
  //                 : _arrayDocs.length
  //               })`
  //             ) : (
  //               <Placeholder animation="glow">
  //                 <Placeholder xs={1} />
  //               </Placeholder>
  //             )}
  //           </Col>

  //           <Col style={{ textAlign: "end" }}>
  //             <CloseButton
  //               onClick={() => {
  //                 // setGridColMDValue(12);
  //               }}
  //             // className="ms-4"
  //             />
  //           </Col>
  //         </Row>
  //       </Card.Header>
  //       {isDocumentLoaded ? (
  //         <Card.Body>
  //           <div id="collapse-listeDocuments">
  //             {_arrayDocs.length > 0
  //               ? _arrayDocs.map((doc, index) => {
  //                 return (
  //                   <RowDocument key={index} props={doc} index={index} />
  //                 );
  //               })
  //               : "Aucun document."}
  //           </div>
  //         </Card.Body>
  //       ) : (
  //         <Card.Body>
  //           <Placeholder as="p" animation="glow">
  //             <Placeholder xs={5} />
  //           </Placeholder>
  //           <Placeholder as="p" animation="glow">
  //             <Placeholder xs={5} />
  //           </Placeholder>
  //           <Placeholder as="p" animation="glow">
  //             <Placeholder xs={5} />
  //           </Placeholder>
  //         </Card.Body>
  //       )}
  //     </Card>
  //   );
  // };

  const CreatePropError = () => {
    const _obj = {
      title: "Une erreur s'est produite",
      extension: "ERROR",
    };
    return _obj;
  };

  //#region Props

  /**
   *
   * @returns Un objet représentant le document
   */
  const CreatePropsDocumentMaintenance = (element) => {
    const _obj = {};
    //le titre et l'extension
    _obj.title = element.k;
    _obj.extension = element.k.split(".").pop();
    try {

      //La fonction appelé lors de l'appuye du bouton 'Voir'
      _obj.VoirDocumentSup = () => DocumentMaintenanceVoirDocumentSup(element);

      //La fonction appelé lors de l'appuye du bouton télécharger
      // _obj.TelechargerDocumentSup = async () => {
      //   return await DocumentMaintenanceGetFile(element.v, true, true);
      // };


      _obj.TelechargerDocumentSup = () => DocumentMaintenanceTelechargerDocumentSup(element);

      _obj.data = element;

    } catch (ex) {


    }
    return _obj;
  };



  /**
   *
   * @returns Un objet représentant le document
   */
  const CreatePropsDocumentInterventionFI = (element) => {
    const _obj = {};

    //le titre et l'extension
    _obj.title = element.k;
    _obj.extension = element.k.split(".").pop();
    try {

      //La fonction appelé lors de l'appuye du bouton 'Voir'
      _obj.VoirDocumentSup = () => DocumentDepannageVoirDocumentSup(element);

      //La fonction appelé lors de l'appuye du bouton télécharger
      _obj.TelechargerDocumentSup = () => DocumentDepannageTelechargerDocumentSup(element);
      // _obj.TelechargerDocumentSup = async () => {
      //   return await GetDocumentFISAV(tokenCt, element.v, false, true);
      // };

      _obj.data = element;

    } catch (ex) {
      console.log("Erreur lors de la récupération de document : " + ex)
    }
    return _obj;
  };


  const DocumentDepannageVoirDocumentSup = async (element) => {
    setShowToast(true);
    setVariantToast("info");
    setMessageToast(`Récupération du document... `);
    setTitleToast(`Document`);
    try {


      //On récupère le fichier en b64
      const b64data = await GetDocumentFISAV(tokenCt, element.v, false, true);


      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(element.k);

      //Transformation en blob
      const blobData = base64toBlob(b64data.v, getMimeTypeFromExtension(ext[0]) );


      //Création de l'URL du fichier
      const url = URL.createObjectURL(blobData);

      //Création du lien
      const aLink = document.createElement('a');
      aLink.href = url;
      aLink.target = "_blank";
      aLink.click();

      //Suppression de l'URL
      URL.revokeObjectURL(url);
      setVariantToast("success");

      setShowToast(false);

    } catch (ex) {
      console.log("Erreur lors de la récupération de document : " + ex)
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    }


  }


  const DocumentDepannageTelechargerDocumentSup = async (element) => {
    setShowToast(true);
    setVariantToast("info");
    setMessageToast(`Téléchargement du document... `);
    setTitleToast(`Document`);
    try {

      //On récupère le fichier en b64
      const b64data = await GetDocumentFISAV(tokenCt, element.v, false, true);

      //Transformation en blob
      const blobData = base64toBlob(b64data.v);

      saveAs(blobData, element.k);
      setVariantToast("success");

      setShowToast(false);

    } catch (ex) {
      console.log("Erreur lors du téléchargement de document : " + ex)
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    }


  }



  // /**
  //    * La méthode appellé pour voir un document de maintenance dans un viewer
  //    */
  // const DocumentDepannageVoirDocumentSupViewer = async (element) => {

  //   //On ouvre une nouvelle fenêtre d'attente
  //   let targetWindow = window.open("/waiting");

  //   //On récupère le fichier en b64
  //   try {


  //     const b64data = await GetDocumentFISAV(tokenCt, element.v, false, true);

  //     //On transforme le fichier en blob
  //     const blobData = base64toBlob(b64data.v);

  //     //On créer l'URL utilisé par les viewers
  //     const url = URL.createObjectURL(blobData);

  //     //On l'enregistre dans le viewerContext
  //     viewerCt.setViewer(url);

  //     //On navigue la page d'attente au viewer qui chargera l'URL du fichier
  //     //Le bon viewer est déterminé par l'extension
  //     targetWindow.location.href = GetURLLocationViewerFromExtension(
  //       element.k.split(".").pop()
  //     );
  //   } catch (error) {
  //     console.log("Erreur lors de la récupération des données : ", error)
  //     targetWindow.close();
  //   }
  // };



  /**
   * La méthode appellé pour voir un document de maintenance dans une autre fenêtre
   */
  const DocumentMaintenanceVoirDocumentSup = async (element) => {
    setShowToast(true);
    setVariantToast("info");
    setMessageToast(`Récupération du document... `);
    setTitleToast(`Document`);
    //On récupère le fichier en b64
    try {
      const b64data = await DocumentMaintenanceGetFile(element.v, true, true);
      
      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(element.k);

      //Transformation en blob
      const blobData = base64toBlob(b64data.v, getMimeTypeFromExtension(ext[0]) );

      //Création de l'URL du fichier
      const url = URL.createObjectURL(blobData);

      //Création du lien
      const aLink = document.createElement('a');
      aLink.href = url;
      aLink.target = "_blank";
      aLink.click();

      //Suppression de l'URL
      URL.revokeObjectURL(url);
      setVariantToast("success");

      setShowToast(false);


    } catch (ex) {
      console.log("Erreur lors de la récupération de document : " + ex)
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    }
  }


  const DocumentMaintenanceTelechargerDocumentSup = async (element) => {
    setShowToast(true);
    setVariantToast("info");
    setMessageToast(`Téléchargement du document... `);
    setTitleToast(`Document`);

    try {

      
      const b64data = await DocumentMaintenanceGetFile(element.v, true, true);

      //Transformation en blob
      const blobData = base64toBlob(b64data.v);

      saveAs(blobData, element.k);

      setVariantToast("success");
      setShowToast(false);


    } catch (ex) {
      console.log("Erreur lors du téléchargement du document : " + ex)
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    }


  }




  // /**
  //  * La méthode appellé pour voir un document de maintenance via un viewer
  //  */
  // const DocumentMaintenanceVoirDocumentSupViewer = async (element) => {
  //   //On ouvre une nouvelle fenêtre d'attente
  //   let targetWindow = window.open("/waiting");

  //   //On récupère le fichier en b64
  //   const b64data = await DocumentMaintenanceGetFile(element.v, false, true);

  //   //On transforme le fichier en blob
  //   const blobData = base64toBlob(b64data.v);

  //   //On créer l'URL utilisé par les viewers
  //   const url = URL.createObjectURL(blobData);

  //   //On l'enregistre dans le viewerContext
  //   viewerCt.setViewer(url);

  //   //On navigue la page d'attente au viewer qui chargera l'URL du fichier
  //   //Le bon viewer est déterminé par l'extension
  //   targetWindow.location.href = GetURLLocationViewerFromExtension(
  //     element.k.split(".").pop()
  //   );
  // };

  const DocumentMaintenanceGetFile = async (v, telecharger, returnData) => {
    const splitPop = v.split("|").pop();
    const splitShift = v.split("|").shift();
    var _kv;
    switch (splitPop) {
      case "CERFA":
        _kv = await GetDocumentPrestationCERFA(
          tokenCt,
          splitShift,
          telecharger,
          returnData
        );
        break;

      case "RAPPORT":
        _kv = await GetDocumentPrestationRapport(
          tokenCt,
          splitShift,
          telecharger,
          returnData
        );
        break;

      case "TICKET":
        _kv = await GetDocumentPrestationTicket(
          tokenCt,
          splitShift,
          telecharger,
          returnData
        );
        break;

      case "EXTRANET":
        _kv = await GetDocumentPrestationExtranet(
          tokenCt,
          splitShift,
          telecharger,
          returnData
        );
        break;

      default:
        break;
    }
    return _kv;
  };

  /**
   * Créer le props pour le fichier ZIP
   * @param {*} _arrDocT
   * @param {*} presta
   * @returns
   */
  const CreatePropsDocPrestaZIP = async (_arrDocT, presta) => {
    const _obj = {};
    _obj.title = "Tous les documents";
    _obj.extension = "zip";


    const TelechargerZIPSup = async (presta) => {
      setTitleToast(`Téléchargement de ${_arrDocT.length} documents`)
      setMessageToast("");
      setVariantToast("info")
      setShowToast(true);

      const zip = JSZip();
      let _arrDocs = [];

      for (let index = 0; index < _arrDocT.length; index++) {
        setMessageToast(`Téléchargement du document ${index + 1} / ${_arrDocT.length}`)
        const element = _arrDocT[index];

        let _data = await DocumentMaintenanceGetFile(element.data.v, false, true);
        let _kv = JSON.parse(JSON.stringify(_data));
        if (_kv) {
          _arrDocs.push([_kv.v, _kv.k]);
        }
      }

      var _errors = 0;
      _arrDocs.forEach((kv, i) => {
        try {
          let _b64 = kv[0];
          let _blob = base64toBlob(_b64);
          zip.file(kv[1], _blob);

        } catch (error) {
          console.log("Impossible de zipper")
          console.log(error);
          setVariantToast("danger")
          setMessageToast("Une erreur est survenue. Merci de rééssayer plus tard.")
          _errors += 1;
        }
      });

      const _v = await zip.generateAsync({ type: 'base64' })
      const _k = `Documents PC${presta.IdPrestationContrat}_${presta.DateInterventionPrestation}`;


      if (_errors == 0) {
        setVariantToast("success");
        setMessageToast("Téléchargement terminé")
      }
      return { k: _k, v: _v };

    }


    _obj.TelechargerDocumentSup = async () => await TelechargerZIPSup(presta);
    _obj.type = "application/zip";
    return _obj;
  };

  //#endregion

  //#region Documents

  const [documents, setDocuments] = useState([]);
  const [showModalDoc, setShowModalDoc] = useState(false);
  const [isDocumentLoaded, setIsDocumentLoaded] = useState(false);


  const FetchSetDocuments = async (data, presta) => {
    let _arrDocs = [];
    const arrData = data;

    if (data instanceof Error) {
      const _arrError = [CreatePropError()];
      //Erreur
      setDocuments(_arrError);
      setIsDocumentLoaded(true);
      // setGridColMDValue(10);

      return;
    }


    if (arrData.length && arrData.length > 0) {
      for (let index = 0; index < arrData.length; index++) {
        const element = arrData[index];
        _arrDocs.push(CreatePropsDocumentMaintenance(element));
      }
    }
    else if(arrData)
    {
      _arrDocs.push(CreatePropsDocumentMaintenance(arrData));

    }


    if (_arrDocs.length > 1) {
      let tempDocs = [];

      tempDocs.push(await CreatePropsDocPrestaZIP(_arrDocs, presta));
      _arrDocs = [...tempDocs, ..._arrDocs];
    }

    setDocuments(_arrDocs);
    setIsDocumentLoaded(true);
    setShowModalDoc(true);
    // setGridColMDValue(10);
  };


  const HandleAfficherDocuments = async (presta) => {
    if (presta.IdDossierIntervention > 0 && presta.IdEtat === 96) {
      // setGridColMDValue(10);
      setIsDocumentLoaded(false);
      setShowModalDoc(true);

      await GetDocumentPrestation(
        tokenCt,
        presta.IdDossierIntervention,
        FetchSetDocuments,
        presta
      );
    } else {
      // setGridColMDValue(12);
    }
  };

  const ModalDocuments = () => {
    const PrestaCtx = useContext(PrestaContext);

    // const [gridColMDValue, setGridColMDValue] = useState(12);

    const modalBodyRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    // eslint-disable-next-line
    const [isAtTop, setIsAtTop] = useState(true);

    useEffect(() => {
      const checkScrollability = () => {
        if (modalBodyRef.current) {
          const { scrollHeight, clientHeight } = modalBodyRef.current;
          setIsScrollable(scrollHeight > clientHeight);
        }
      };
      const handleScroll = () => {
        if (modalBodyRef.current) {
          const { scrollTop } = modalBodyRef.current;
          if (scrollTop > 0) {
            modalBodyRef.current.classList.add("no-scroll-indicator");
            setIsAtTop(false);
          } else {
            modalBodyRef.current.classList.remove("no-scroll-indicator");
            setIsAtTop(true);
          }
        }
      };

      checkScrollability();
      if (modalBodyRef.current) {
        modalBodyRef.current.addEventListener("scroll", handleScroll);
      }
      window.addEventListener("resize", checkScrollability);

      return () => {
        if (modalBodyRef.current) {
          // eslint-disable-next-line
          modalBodyRef.current.removeEventListener("scroll", handleScroll);
        }
        window.removeEventListener("resize", checkScrollability);
      };
      // eslint-disable-next-line
    }, [documents]);

    const scrollToBottom = () => {
      if (modalBodyRef.current) {
        modalBodyRef.current.scrollTo({
          top: modalBodyRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };

    const CardDocumentsBody = () => {
      if (!isDocumentLoaded) {
        return (
          <>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
          </>
        );
      }
      if (documents.length === 0) return <div>Aucun document.</div>;

      return (
        <div>
          {/* <RowDocument props={{ title: "Tous les documents", extension: "zip", size: " " }} /> */}
          {documents.map((doc, index) => (
            <RowDocument key={index} props={doc} index={index} />
          ))}
        </div>
      );
    };

    return (
      <Modal
        dialogClassName="modal-listing"
        show={showModalDoc || PrestaCtx.showModalDoc}
        onHide={() => {
          setShowModalDoc(false);
          PrestaCtx.setShowModalDoc(false);
        }}
        backdrop="static"
        keyboard={false}
        animation={false}
      >
        <Modal.Header>
          <Modal.Title>
            <FontAwesomeIcon icon={faFile} />
            Liste des documents
          </Modal.Title>
          <Button
            className="close-modal"
            onClick={() => setShowModalDoc(false)}
          ><FontAwesomeIcon icon={faXmark} />
          </Button>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef} className={`modal-body ${isScrollable ? "scrollable" : ""}`}>
          <CardDocumentsBody />
          {isScrollable && (
            <button onClick={scrollToBottom} className="scroll-modal">
              <FontAwesomeIcon icon={faArrowDown} size="lg" />
            </button>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  useEffect(() => {
    if (PrestaCtx) {
      if (PrestaCtx.showModalDoc) {
        HandleAfficherDocuments(PrestaCtx.prestaSelected);
      }
    }
    // eslint-disable-next-line
  }, [PrestaCtx && PrestaCtx.showModalDoc]);
  //#endregion

  //#endregion

  //#region Factures


  const HandleSelectorFacture = async () => {
    let _arrayOfFactures = [];

    for (let index = 0; index < arraySelector.length; index++) {
      const element = arraySelector[index];
      _arrayOfFactures.push(Data()[element]);
    }

    //Création du fichier ZIP
    // let _targetWindow = window.open("/waiting");
    let _NbErreur = 0;

    const CreateArrayZIP = async () => {

      setShowToast(true);
      setVariantToast("info");
      setMessageToast(`Téléchargement en cours... (0/${_arrayOfFactures.length}) `);
      setTitleToast(`Téléchargement de ${_arrayOfFactures.length} fichiers`);


      for (let index = 0; index < _arrayOfFactures.length; index++) {
        const facture = _arrayOfFactures[index];
        let _kv = await VoirFactureDocument(
          tokenCt,
          facture.IdFacture,
          facture.Type,
          facture.Avoir,
          true
        );

        setMessageToast(`Téléchargement en cours... (${index + 1}/${_arrayOfFactures.length}) `);

        //Transformation en blob
        const base64data = _kv.v;
        if (_kv === 500 || (!_kv.v)) {
          _NbErreur += 1
        } else {
          const _bblob = base64toBlob(base64data);
          // Téléchargement
          saveAs(_bblob, _kv.k);
        }


      }

      // return _arrDocs;
    };

    await CreateArrayZIP();
    if (_NbErreur === 0) {
      setVariantToast("success");
      setMessageToast(`Téléchargement terminé`);
      setTitleToast(`Téléchargement de ${_arrayOfFactures.length} fichiers`);
    } else if (_NbErreur === _arrayOfFactures.length) {
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    } else {
      setVariantToast("warning");
      setMessageToast(`${_NbErreur} document(s) n'ont pas pu être téléchargé. Réessayez plus tard.`);
    }
  };

  const [showModalFacture, setShowModalFacture] = useState(false);


  const ModalFactures = () => {
    const PrestaCtx = useContext(PrestaContext);
    // On utilise les états factures et isFactureLoaded définis ci-dessus (déclarés en haut de TableData.js)

    const modalBodyRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    // eslint-disable-next-line
    const [isAtTop, setIsAtTop] = useState(true);

    useEffect(() => {
      const checkScrollability = () => {
        if (modalBodyRef.current) {
          const { scrollHeight, clientHeight } = modalBodyRef.current;
          setIsScrollable(scrollHeight > clientHeight);
        }
      };
      const handleScroll = () => {
        if (modalBodyRef.current) {
          const { scrollTop } = modalBodyRef.current;
          if (scrollTop > 0) {
            modalBodyRef.current.classList.add("no-scroll-indicator");
            setIsAtTop(false);
          } else {
            modalBodyRef.current.classList.remove("no-scroll-indicator");
            setIsAtTop(true);
          }
        }
      };

      checkScrollability();
      if (modalBodyRef.current) {
        modalBodyRef.current.addEventListener("scroll", handleScroll);
      }
      window.addEventListener("resize", checkScrollability);

      return () => {
        if (modalBodyRef.current) {
          // eslint-disable-next-line
          modalBodyRef.current.removeEventListener("scroll", handleScroll);
        }
        window.removeEventListener("resize", checkScrollability);
      };
      // eslint-disable-next-line
    }, [documents]);

    const scrollToBottom = () => {
      if (modalBodyRef.current) {
        modalBodyRef.current.scrollTo({
          top: modalBodyRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
    };

    const CardFacturesBody = () => {
      if (!isDocumentLoaded) {
        return (
          <>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
            <Placeholder as="p" animation="glow">
              <Placeholder xs={5} />
            </Placeholder>
          </>
        );
      }
      if (documents.length === 0) return <div>Aucune facture.</div>;

      return (
        <div>
          {documents.map((document, index) => (
            <RowDocument key={index} props={document} index={index} />
          ))}
        </div>
      );
    };
    return (
      <Modal
        dialogClassName="modal-listing"
        show={showModalFacture || PrestaCtx.showModalFacture}
        onHide={() => {
          setShowModalFacture(false);
        }}
        backdrop="static"
        keyboard={false}
        animation={false}
      >
        <Modal.Header>
          <Modal.Title>
            <FontAwesomeIcon icon={faFile} />
            Liste des documents
          </Modal.Title>
          <Button
            className="close-modal"
            onClick={() => setShowModalFacture(false)}
          ><FontAwesomeIcon icon={faXmark} />
          </Button>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef} className={`modal-body ${isScrollable ? "scrollable" : ""}`}>
          <CardFacturesBody />
          {isScrollable && (
            <button onClick={scrollToBottom} className="scroll-modal">
              <FontAwesomeIcon icon={faArrowDown} size="lg" />
            </button>
          )}
        </Modal.Body>
      </Modal>
    );
  };

  useEffect(() => {
    if (PrestaCtx) {
      if (PrestaCtx.showModalFacture) {
        HandleAfficherFacture(PrestaCtx.prestaSelected);
      }
    }
    // eslint-disable-next-line
  }, [PrestaCtx && PrestaCtx.showModalFacture]);


  //#endregion

  //#region Intervention


  /**
   *
   * @returns Un objet représentant le document
   */
  const CreatePropsDocumentInterventionFacture = (element) => {
    const _obj = {};

    //le titre et l'extension
    _obj.title = element.k;
    _obj.extension = element.k.split(".").pop();

    //La fonction appelé lors de l'appuye du bouton 'Voir'
    _obj.VoirDocumentSup = () => FactureMaintenanceVoirDocumentSup(element);

    _obj.TelechargerDocumentSup = () => FactureMaintenanceTelechargerDocumentSup(element);
    //La fonction appelé lors de l'appuye du bouton télécharger
    // _obj.TelechargerDocumentSup = async () => {
    //   return await VoirFactureDocument(tokenCt, element.v, "Facture SAV", false, true);
    // };

    _obj.data = element;

    return _obj;
  };


  const FactureMaintenanceVoirDocumentSup = async (element) => {
    setShowToast(true);
    setVariantToast("info");
    setMessageToast(`Récupération du document... `);
    setTitleToast(`Document`);

    try {


      //On récupère le fichier en b64
      const b64data = await VoirFactureDocument(tokenCt, element.v, "Facture SAV", false, true);

      //Transformation en blob
      const blobData = base64toBlob(b64data.v);

      //Création de l'URL du fichier
      const url = URL.createObjectURL(blobData);

      //Création du lien
      const aLink = document.createElement('a');
      aLink.href = url;
      aLink.target = "_blank";
      aLink.click();

      //Suppression de l'URL
      URL.revokeObjectURL(url);

      setVariantToast("success")
      setMessageToast("Document récupéré.")

    } catch (error) {

      console.log("Erreur lors de la récupération du document : " + error)
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    }
  }


  const FactureMaintenanceTelechargerDocumentSup = async (element) => {
    setShowToast(true);
    setVariantToast("info");
    setMessageToast(`Téléchargement du document... `);
    setTitleToast(`Document`);

    try {


      //On récupère le fichier en b64
      const b64data = await VoirFactureDocument(tokenCt, element.v, "Facture SAV", false, true);

      //Transformation en blob
      const blobData = base64toBlob(b64data.v);

      saveAs(blobData, element.k)

      setVariantToast("success")
      setMessageToast("Document téléchargé.")

    } catch (error) {

      console.log("Erreur lors de la récupération du document : " + error)
      setVariantToast("danger");
      setMessageToast("Un problème est survenu. Réessayez plus tard.");
    }

  }




  // /**
  //   * La méthode appellé pour voir un document de maintenance dans un viewer
  //   */
  // const FactureMaintenanceVoirDocumentSupViewer = async (element) => {
  //   //On ouvre une nouvelle fenêtre d'attente
  //   let targetWindow = window.open("/waiting");

  //   //On récupère le fichier en b64
  //   const b64data = await VoirFactureDocument(tokenCt, element.v, "Facture SAV", false, true);

  //   //On transforme le fichier en blob
  //   const blobData = base64toBlob(b64data.v);

  //   //On créer l'URL utilisé par les viewers
  //   const url = URL.createObjectURL(blobData);

  //   //On l'enregistre dans le viewerContext
  //   viewerCt.setViewer(url);

  //   //On navigue la page d'attente au viewer qui chargera l'URL du fichier
  //   //Le bon viewer est déterminé par l'extension
  //   targetWindow.location.href = GetURLLocationViewerFromExtension(
  //     element.k.split(".").pop()
  //   );
  // };



  const CreatePropsDocumentInterventionZIP = (_arrDocsFI, _arrDocsFA) => {
    const _obj = {};
    _obj.title = "Tous les documents";
    _obj.extension = "zip";

    const TelechargerZIPSup = async (IdDossierInterventionSAV) => {
      setShowToast(true);
      setVariantToast("info");
      setMessageToast(`Téléchargement en cours... (0/${_arrDocsFI.length + _arrDocsFA.length}) `);

      const zip = JSZip();
      let _arrDocs = [];


      for (let index = 0; index < _arrDocsFI.length; index++) {
        try {
          setMessageToast(`Téléchargement en cours... (${index + 1}/${_arrDocsFI.length + _arrDocsFA.length}) `);
          const element = _arrDocsFI[index];
          const _kv = await GetDocumentFISAV(
            tokenCt,
            element.data.v,
            false,
            true
          );
          const _arrDocFI = [_kv.v, _kv.k];
          _arrDocs.push(_arrDocFI);
          
        } catch (error) {
          
        }
      }

      for (let index = 0; index < _arrDocsFA.length; index++) {
        try {

        setMessageToast(`Téléchargement en cours... (${_arrDocsFI.length + index + 1}/${_arrDocsFI.length + _arrDocsFA.length}) `);

        const element = _arrDocsFA[index];
        const _kv = await VoirFactureDocument(
          tokenCt,
          element.data.v,
          "Facture SAV",
          false,
          true
        );
        const _arrDocFA = [_kv.v, _kv.k];

        _arrDocs.push(_arrDocFA);
          
        } catch (error) {
          
        }
      }


      let _error = 0;
      _arrDocs.forEach((kv, i) => {
        try {
          let _b64 = kv[0];
          let _blob = base64toBlob(_b64);
          zip.file(kv[1], _blob);


        } catch (error) {
          console.log("Impossible de zipper")
          console.log(error);
          setVariantToast("danger");
          setMessageToast("Un problème est survenu. Réessayez plus tard.");
          _error = 1;
        }
      });

      const _v = await zip.generateAsync({ type: 'base64' })
      const _k = `Tous les documents`;
      if (_error = 0)
      {

        setVariantToast("success");
        setMessageToast(`Téléchargement terminé`);
        setTitleToast(`Téléchargement de ${_arrDocs.length} fichiers`);
      }
      return { k: _k, v: _v };


      // await TelechargerZIP(
      //   _arrDocs,
      //   `Intervention N° ${IdDossierInterventionSAV}`
      // );
    };

    // _obj.TelechargerDocumentSup = async () => await TelechargerZIPSup();
    _obj.TelechargerDocumentSup =  () =>  TelechargerZIPSup();

    _obj.type = "application/zip";
    return _obj;
  };





















  const GetListeDocIntervention = async (IdDossierInterventionSAV) => {
    setIsDocumentLoaded(false);

    let _arrDocs = [];

    let _arrFI = [];
    let _arrFA = [];
    // 2 - Set les FI
    const FetchSetDataFIPart = (data) => {
      if (data.length) {
        //Il y a plusieurs FI
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          const _obj = CreatePropsDocumentInterventionFI(element);
          _arrFI.push(_obj);
        }
      } else if (data.k) {
        const _obj = CreatePropsDocumentInterventionFI(data);

        _arrFI.push(_obj);
      }
    };

    //4 - Set les factures
    const FetchSetDataFacturePart = (data) => {
      if (data.length) {
        //Il y a plusieurs factures
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          const _obj = CreatePropsDocumentInterventionFacture(element);

          _arrFA.push(_obj);
        }
      } else if (data.k) {
        const _obj = CreatePropsDocumentInterventionFacture(data);

        _arrFA.push(_obj);
      }

      if (_arrFA.length + _arrFI.length > 1) {
        _arrDocs.push(
          CreatePropsDocumentInterventionZIP(
            _arrFI,
            _arrFA,
            IdDossierInterventionSAV
          )
        );
      }

      _arrDocs = [..._arrDocs, ..._arrFI, ..._arrFA];

      setDocuments(_arrDocs);
      setIsDocumentLoaded(true);
      setShowModalFacture(true);
    };

    //1 - Demande les FI
    await GetListeFIIntervention(
      tokenCt,
      IdDossierInterventionSAV,
      FetchSetDataFIPart
    );

    //3 - Demande les factures
    await GetListeFactureIntervention(
      tokenCt,
      IdDossierInterventionSAV,
      FetchSetDataFacturePart
    );
  };

  const HandleAfficherFacture = (inter) => {
    if (inter) {
      setDocuments([]);
      // setGridColMDValue(10);
      // Charge les factures
      GetListeDocIntervention(inter.IdDossierInterventionSAV);
      setShowModalFacture(true);

    } else {
      // setGridColMDValue(12);
    }
  };

  //#endregion

  //#endregion

  return (
    <BreakpointProvider>
      {TopPannel()}
      <Container fluid className="container-table">
        <ModalList />
        <Breakpoint large up>
          <Row>
            <Col>
              <Table className="table-presta">
                <TableHeaders />
                {props.IsLoaded ? (
                  <TableBody />
                ) : (
                  <PlaceHolderTableLine
                    numberOfLines={
                      props.placeholdeNbLine ? props.placeholdeNbLine : 5
                    }
                  />
                )}
              </Table>
            </Col>

            {/* {gridColMDValue !== 12 && <Col md={"auto"}>{CardDocs()}</Col>} */}
          </Row>
        </Breakpoint>

        <Breakpoint medium down>
          <GridCards />
        </Breakpoint>
        <Row>{props.Pagination && <Col>{TablePagination()}</Col>}</Row>
        <ToastContainer
          className="p-3"
          position={"bottom-end"}
        // style={{ zIndex: 1 }}
        >
          <Toast show={showToast} bg={variantToast} onClose={() => setShowToast(false)}>
            <Toast.Header> <strong className="me-auto">{titleToast}</strong>
            </Toast.Header>
            <Toast.Body>
              <div>{messageToast}</div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </Container>
    </BreakpointProvider>
  );
};

export default TableData;

//#region Editor commun

export const EditorMontant = (data) => {
  try {
    return `${new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
    }).format(data)}`;
  } catch (error) {
    return `${data} €`;
  }
};

export const EditorDateFromDateTime = (data) => {
  let dateRegex = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/;
  let _match = RegexTestAndReturnMatch(data, dateRegex);
  if (_match !== data) {
    return _match;
  }
  dateRegex = /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}/;
  _match = RegexTestAndReturnMatch(data, dateRegex);
  if (_match !== data) {
    return _match;
  }

  return data;
};

export const EditorActionVoir = (e) => {
  return (
    <Button variant="">
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Voir</Tooltip>}>
        <FontAwesomeIcon icon={faEye} />
      </OverlayTrigger>
    </Button>
  );
};

export const EditorActionTelecharger = (e) => {
  return (
    <Button variant="">
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip>Télécharger</Tooltip>}
      >
        <FontAwesomeIcon icon={faDownload} />
      </OverlayTrigger>
    </Button>
  );
};

export const EditorActionsTooltip = ({ actions }) => {
  const [isActive, setIsActive] = useState(false);

  const popover = (
    <Popover className="editor-actions-tooltip">
      <Popover.Body>
        {actions.map((action, index) => (
          <div
            key={index}
            className={`editor-action-item ${action.className || ""}`}
            onClick={action.onClick}
          >
            <FontAwesomeIcon icon={action.icon} className="action-icon" />
            <span>{action.label}</span>
          </div>
        ))}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement="left"
      overlay={popover}
      trigger="click"
      rootClose
      container={document.body}
      onToggle={(isOpen) => setIsActive(isOpen)}
    >
      <Button variant="link" className={`btn-tooltip ${isActive ? "active" : ""}`}>
        <TooltipSvg />
      </Button>
    </OverlayTrigger>
  );
};

const CreateEditorDocument = (
  methodTitle,
  extension,
  methodTelecharger,
  methodVoir
) => {
  const EditorDocument = (e) => {
    const _obj = {};
    _obj.title = methodTitle(e);
    _obj.extension = extension;
    methodVoir && (_obj.VoirDocumentSup = () => methodVoir(e));
    methodTelecharger &&
      (_obj.TelechargerDocumentSup = () => methodTelecharger(e));

    return <RowDocument props={_obj} />;
  };
  return EditorDocument;
};

const EditorSelection = (e) => {
  let _uid = GenerateUid();
  return <Form.Check id={`selector-check-${_uid}`} defaultChecked={e} />;
};

//#endregion

//#region Helpers
/**
 * 
 * @param {string} fieldname 
 * @param {boolean} filter 
 * @param {string} caption 
 * @param {Function} editor 
 * @returns 
 */
export const CreateNewHeader = (fieldname, filter, caption, editor) => {
  let _header = {
    fieldname: fieldname,
    filter: filter,
    caption: caption,
    editor: editor,
  };
  return _header;
};

/**
 * 
 * @param {boolean} isFilter 
 * @param {boolean} isCheckbox 
 * @param {boolean} isRange 
 * @param {boolean} isSearchCol 
 * @param {boolean} isRangeDate 
 * @returns 
 */
export const CreateFilter = (
  isFilter,
  isCheckbox,
  isRange,
  isSearchCol,
  isRangeDate
) => {
  return {
    isFilter: isFilter,
    isCheckbox: isCheckbox,
    isRange: isRange,
    isSearchCol: isSearchCol,
    isRangeDate: isRangeDate,
  };
};

/**
 * 
 * @param {string} fieldname 
 * @param {boolean} isH1 
 * @param {boolean} isSearchable 
 * @param {boolean} isSelectable 
 * @param {Function} editor 
 * @param {string} tagMethod 
 * @returns 
 */
export const CreateNewCell = (
  fieldname,
  isH1,
  isSearchable,
  isSelectable,
  editor,
  tagMethod
) => {
  let _cell = {
    fieldname: fieldname,
    isH1: isH1,
    isSearchable: isSearchable,
    isSelectable: isSelectable,
    editor: editor,
    tagMethod: tagMethod,
  };
  return _cell;
};

export const CreateNewUnboundHeader = (filter, caption, tagMethod) => {
  let _header = {
    fieldname: "unboundColonne",
    filter: filter,
    caption: caption,
    tagMethod: tagMethod,
  };
  return _header;
};

export const CreateNewUnboundCell = (
  isH1,
  isSearchable,
  isSelectable,
  editor,
  tagMethod
) => {
  let _cell = {
    fieldname: "unboundColonne",
    isH1: isH1,
    isSearchable: isSearchable,
    isSelectable: isSelectable,
    editor: editor,
    tagMethod: tagMethod,
  };
  return _cell;
};

export const CreateNewDocumentCell = (
  methodTitle,
  extension,
  methodTelecharger,
  methodVoir
) => {
  let _cell = CreateNewUnboundCell(
    false,
    false,
    false,
    CreateEditorDocument(methodTitle, extension, methodTelecharger, methodVoir)
  );

  return _cell;
};

export const CreateNewHeaderSelector = (tagMethod) => {
  return CreateNewHeader(TAGSELECTION, false, "Selection", EditorSelection);
};

export const CreateNewCellSelector = (tagMethod) => {
  return CreateNewCell(
    TAGSELECTION,
    false,
    false,
    true,
    EditorSelection,
    `selection_${tagMethod}`
  );
};

export const CreateNewButtonFilter = (fieldname, value, editor) => {
  let _btFilter = { fieldname: fieldname, value: value, editor: editor };
  return _btFilter;
};

export const CreateNewCardModel = (CardBody, CardTitle, CardSubtitle) => {
  let _obj = {
    header: {
      title: {
        fieldname: "unboundColonne",
        editor: CardTitle,
      },
      subtitle: {
        fieldname: "unboundColonne",
        editor: CardSubtitle,
      },
    },
    body: {
      fieldname: "unboundColonne",
      editor: CardBody,
    },
  };
  return _obj;
};

//#endregion
